import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule, PercentPipe } from '@angular/common';
import { ZorroModule } from './zorro.module';
import { LiberroButtonComponent } from '../shared/liberro-button/liberro-button.component';
import { LiberroSectionHeaderComponent } from '../shared/liberro-section-header/liberro-section-header.component';
import { LiberroOptionListComponent } from '../shared/liberro-option-list/liberro-option-list.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AppModePipe } from '../pipes/app-mode.pipe';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { LiberroBackButtonComponent } from '../shared/liberro-back-button/liberro-back-button.component';
import { LiberroInputComponent } from '../shared/liberro-input/liberro-input.component';
import { LiberroInfoBoxComponent } from '../shared/liberro-info-box/liberro-info-box.component';
import { LiberroDisclaimerComponent } from '../shared/liberro-disclaimer/liberro-disclaimer.component';
import { LiberroFaqComponent } from '../shared/liberro-faq/liberro-faq.component';
import { LiberroFaqItemDirective } from '../shared/liberro-faq/liberro-faq-item.directive';
import { IsFaqActivePipe } from '../shared/liberro-faq/liberro-faq-is-active.pipe';
import { LiberroHighlightedContentComponent } from '../shared/liberro-highlighted-content/liberro-highlighted-content.component';
import { LiberroHeaderSubmenuTileComponent } from '../shared/liberro-header-submenu-tile/liberro-header-submenu-tile.component';
import { LiberroAvatarPhotoComponent } from '../shared/liberro-avatar-photo/liberro-avatar-photo.component';
import { LiberroTaggedTextComponent } from '../shared/liberro-tagged-text/liberro-tagged-text.component';
import { LiberroSegmentedSwitchComponent } from '../shared/liberro-segmented-switch/liberro-segmented-switch.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LiberroSwitchComponent } from '../shared/liberro-switch/liberro-switch.component';
import { LiberroPortfoliosOverviewListComponent } from '../shared/liberro-portfolios-overview-list/liberro-portfolios-overview-list.component';
import { LiberroShowMoreLinkComponent } from '../shared/liberro-show-more-link/liberro-show-more-link.component';
import { LiberroHistoryDevelopmentChartComponent } from '../shared/liberro-history-development-chart/liberro-history-development-chart.component';
import { LiberroFutureDevelopmentChartComponent } from '../shared/liberro-future-development-chart/liberro-future-development-chart.component';
import { LiberroInvestmentCompositionChartComponent } from '../shared/liberro-investment-composition-chart/liberro-investment-composition-chart.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { LiberroChartPeriodsSwitchComponent } from '../shared/liberro-chart-periods-switch/liberro-chart-periods-switch.component';
import { PricePipe } from 'src/pipes/price.pipe';
import { ManagementTypePipe } from 'src/pipes/management-type.pipe';
import { LiberroSpinnerComponent } from '../shared/liberro-spinner/liberro-spinner.component';
import { LiberroDataLoadErrorComponent } from '../shared/liberro-data-load-error/liberro-data-load-error.component';
import { LiberroHotlineAvailabilityComponent } from '../shared/liberro-hotline-availability/liberro-hotline-availability.component';
import { LiberroTabsComponent } from '../shared/liberro-tabs/liberro-tabs.component';
import { LiberroTabDirective } from '../shared/liberro-tabs/liberro-tab.directive';
import { YearsTranslatePipe } from 'src/pipes/years-translate.pipe';
import { MinutesTranslatePipe } from 'src/pipes/minutes-translate.pipe';
import { TransactionPricePipe } from 'src/pipes/transaction-price.pipe';
import { LiberroImgUploaderComponent } from '../shared/liberro-img-uploader/liberro-img-uploader.component';
import { LiberroContactDetailComponent } from 'src/shared/liberro-contact-detail/liberro-contact-detail.component';
import { RouterModule } from '@angular/router';
import { LiberroHelpBoxComponent } from 'src/shared/liberro-help-box/liberro-help-box.component';
import { LiberroBadgeComponent } from '../shared/liberro-badge/liberro-badge.component';
import { LiberroTooltipContentComponent } from '../shared/liberro-tooltip-content/liberro-tooltip-content.component';
import { TooltipHeaderDirective } from '../shared/liberro-tooltip-content/tooltip-header.directive';
import { LiberroPaginationComponent } from '../shared/liberro-pagination/liberro-pagination.component';
import { EntryFeeCalcTooltipContentComponent } from '../shared/entry-fee-calc-tooltip-content/entry-fee-calc-tooltip-content.component';
import { LiberroNotificationComponent } from '../shared/liberro-notification/liberro-notification.component';
import { LiberroSelectComponent } from '../shared/liberro-select/liberro-select.component';
import { LiberroInvestmentTileComponent } from 'src/shared/liberro-investment-tile/liberro-investment-tile.component';
import { LiberroRegularWithdrawalInvestmentTileComponent } from 'src/shared/liberro-regular-withdrawal-investment-tile/liberro-regular-withdrawal-investment-tile.component';
import { LiberroDraftCardComponent } from '../shared/liberro-draft-card/liberro-draft-card.component';
import { RegularWithdrawalDraftCardComponent } from 'src/shared/regular-withdrawal-draft-card/regular-withdrawal-draft-card.component';
import { LiberroSwipeDirective } from 'src/shared/directives/liberro-swipe.directive';
import { PreventNumberWheelDirective } from 'src/shared/directives/prevent-number-wheel.directive';
import { DayDifferencePipe } from 'src/pipes/days-diff.pipe';
import { FeeInfoTooltipComponent } from '../shared/fee-info-tooltip/fee-info-tooltip.component';
import { TranslateTimeUnitPipe } from 'src/pipes/translate-time-unit.pipe';
import { LiberroThematicStrategyCardComponent } from '../shared/liberro-thematic-strategy-card/liberro-thematic-strategy-card.component';
import { LiberroThematicStrategiesCarouselComponent } from '../shared/liberro-thematic-strategies-carousel/liberro-thematic-strategies-carousel.component';
import { InvestmentsFrequencyPipe } from 'src/pipes/investments-frequency.pipe';
import { LiberroDropdownMenuListComponent } from 'src/shared/liberro-dropdown-menu-list/liberro-dropdown-menu-list.component';
import { LiberroInvestmentSelectDropdownComponent } from 'src/shared/liberro-investment-select-dropdown/liberro-investment-select-dropdown.component';
import { LiberroMobileBottomOverlaySheetComponent } from 'src/shared/liberro-mobile-bottom-overlay-sheet/liberro-mobile-bottom-overlay-sheet.component';
import { LiberroMobileExplainTooltipSheetComponent } from 'src/shared/liberro-mobile-explain-tooltip-sheet/liberro-mobile-explain-tooltip-sheet.component';
import { LiberroSliderComponent } from 'src/shared/liberro-slider/liberro-slider.component';
import { LiberroExplainBoxComponent } from 'src/shared/liberro-explain-box/liberro-explain-box.component';
import { LiberroPlaceholderContentComponent } from 'src/shared/liberro-placeholder-content/liberro-placeholder-content.component';
import { LiberroTransactionItemComponent } from '../shared/liberro-transaction-item/liberro-transaction-item.component';
import { LiberroHelpSectionComponent } from '../shared/liberro-help-section/liberro-help-section.component';
import { LiberroBackcastingChartComponent } from 'src/shared/liberro-backcasting-chart/liberro-backcasting-chart.component';
import { LiberroDatePickerComponent } from '../shared/liberro-date-picker/liberro-date-picker.component';
import { LiberroRegularPaymentComponent } from '../shared/liberro-regular-payment/liberro-regular-payment.component';
import { LiberroOnetimePaymentComponent } from '../shared/liberro-onetime-payment/liberro-onetime-payment.component';
import { LiberroEntryFeePaymentComponent } from '../shared/liberro-entry-fee-payment/liberro-entry-fee-payment.component';
import { PaymentRowComponent } from 'src/shared/liberro-payment-row/payment-row.component';
import { QrPaymentComponent } from 'src/shared/qr-payment/qr-payment.component';
import { RegularDepositfeeInfoComponent } from 'src/shared/regular-deposit-fee-info/regular-deposit-fee-info.component';
import { LiberroBoxConsultantComponent } from '../shared/liberro-box-consultant/liberro-box-consultant.component';
import { NotificationContentParserPipe } from 'src/pipes/notification-content-parser.pipe';
import { LiberroInstrumentChartComponent } from 'src/shared/liberro-instrument-chart/liberro-instrument-chart.component';
import { TooltipAutoCloseDirective } from 'src/shared/directives/tooltip-registration.directive';
import { MobileExplainTooltipSheetDirective } from 'src/shared/directives/mobile-explain-tooltip-sheet.directive';
import { LiberroInvestmentBadgesComponent } from '../shared/liberro-investment-badges/liberro-investment-badges.component';
import { TrimTagNamePipe } from 'src/pipes/trim-tag-name.pipe';
import { LiberroThematicStrategyPreviewStackComponent } from '../shared/liberro-thematic-strategy-preview-stack/liberro-thematic-strategy-preview-stack.component';
import { register } from 'swiper/element/bundle';
import { LiberroAvatarPhotoTaggedComponent } from 'src/shared/liberro-avatar-photo-tagged/liberro-avatar-photo-tagged.component';
import { DisclaimerCarouselModule } from 'src/shared/liberro-disclaimers-carousel/disclaimer-carousel.module';

register();

@NgModule({
  declarations: [
    LiberroButtonComponent,
    LiberroSectionHeaderComponent,
    LiberroOptionListComponent,
    AppModePipe,
    LiberroBackButtonComponent,
    LiberroInputComponent,
    LiberroInfoBoxComponent,
    LiberroDisclaimerComponent,
    LiberroFaqComponent,
    LiberroFaqItemDirective,
    IsFaqActivePipe,
    LiberroHighlightedContentComponent,
    LiberroHeaderSubmenuTileComponent,
    LiberroAvatarPhotoComponent,
    LiberroAvatarPhotoTaggedComponent,
    LiberroTaggedTextComponent,
    LiberroSegmentedSwitchComponent,
    LiberroSwitchComponent,
    LiberroPortfoliosOverviewListComponent,
    LiberroShowMoreLinkComponent,
    LiberroHistoryDevelopmentChartComponent,
    LiberroFutureDevelopmentChartComponent,
    LiberroBackcastingChartComponent,
    LiberroInstrumentChartComponent,
    LiberroInvestmentCompositionChartComponent,
    LiberroChartPeriodsSwitchComponent,
    PricePipe,
    ManagementTypePipe,
    LiberroSpinnerComponent,
    LiberroDataLoadErrorComponent,
    LiberroHotlineAvailabilityComponent,
    LiberroTabsComponent,
    LiberroTabDirective,
    YearsTranslatePipe,
    MinutesTranslatePipe,
    TransactionPricePipe,
    LiberroImgUploaderComponent,
    LiberroContactDetailComponent,
    LiberroHelpBoxComponent,
    LiberroBadgeComponent,
    LiberroTooltipContentComponent,
    TooltipHeaderDirective,
    LiberroPaginationComponent,
    EntryFeeCalcTooltipContentComponent,
    LiberroNotificationComponent,
    LiberroSelectComponent,
    LiberroInvestmentTileComponent,
    LiberroRegularWithdrawalInvestmentTileComponent,
    LiberroPaginationComponent,
    LiberroDraftCardComponent,
    RegularWithdrawalDraftCardComponent,
    LiberroPaginationComponent,
    LiberroSwipeDirective,
    DayDifferencePipe,
    FeeInfoTooltipComponent,
    TranslateTimeUnitPipe,
    LiberroThematicStrategyCardComponent,
    LiberroThematicStrategiesCarouselComponent,
    InvestmentsFrequencyPipe,
    LiberroDropdownMenuListComponent,
    LiberroInvestmentSelectDropdownComponent,
    LiberroMobileBottomOverlaySheetComponent,
    LiberroMobileExplainTooltipSheetComponent,
    LiberroSliderComponent,
    LiberroTransactionItemComponent,
    LiberroHelpSectionComponent,
    PreventNumberWheelDirective,
    TooltipAutoCloseDirective,
    MobileExplainTooltipSheetDirective,
    LiberroExplainBoxComponent,
    LiberroPlaceholderContentComponent,
    LiberroDatePickerComponent,
    LiberroRegularPaymentComponent,
    LiberroOnetimePaymentComponent,
    LiberroEntryFeePaymentComponent,
    PaymentRowComponent,
    QrPaymentComponent,
    RegularDepositfeeInfoComponent,
    LiberroBoxConsultantComponent,
    NotificationContentParserPipe,
    LiberroInvestmentBadgesComponent,
    TrimTagNamePipe,
    LiberroThematicStrategyPreviewStackComponent,
  ],
  imports: [
    CommonModule,
    ZorroModule,
    AngularSvgIconModule,
    TranslatePipe,
    TranslateDirective,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgApexchartsModule,
    DisclaimerCarouselModule,
  ],
  exports:[
    LiberroButtonComponent,
    LiberroSectionHeaderComponent,
    LiberroOptionListComponent,
    ZorroModule,
    AppModePipe,
    LiberroBackButtonComponent,
    LiberroInputComponent,
    LiberroInfoBoxComponent,
    LiberroDisclaimerComponent,
    LiberroFaqComponent,
    LiberroFaqItemDirective,
    IsFaqActivePipe,
    LiberroHighlightedContentComponent,
    LiberroHeaderSubmenuTileComponent,
    LiberroAvatarPhotoComponent,
    LiberroAvatarPhotoTaggedComponent,
    LiberroTaggedTextComponent,
    LiberroSegmentedSwitchComponent,
    LiberroSwitchComponent,
    LiberroPortfoliosOverviewListComponent,
    LiberroShowMoreLinkComponent,
    LiberroHistoryDevelopmentChartComponent,
    LiberroFutureDevelopmentChartComponent,
    LiberroBackcastingChartComponent,
    LiberroInstrumentChartComponent,
    LiberroInvestmentCompositionChartComponent,
    LiberroChartPeriodsSwitchComponent,
    PricePipe,
    ManagementTypePipe,
    LiberroSpinnerComponent,
    LiberroDataLoadErrorComponent,
    LiberroHotlineAvailabilityComponent,
    LiberroTabsComponent,
    LiberroTabDirective,
    YearsTranslatePipe,
    MinutesTranslatePipe,
    TransactionPricePipe,
    LiberroImgUploaderComponent,
    LiberroContactDetailComponent,
    LiberroHelpBoxComponent,
    FormsModule,
    LiberroBadgeComponent,
    LiberroTooltipContentComponent,
    TooltipHeaderDirective,
    LiberroPaginationComponent,
    EntryFeeCalcTooltipContentComponent,
    LiberroSelectComponent,
    LiberroInvestmentTileComponent,
    LiberroRegularWithdrawalInvestmentTileComponent,
    LiberroDraftCardComponent,
    RegularWithdrawalDraftCardComponent,
    LiberroSwipeDirective,
    LiberroThematicStrategyCardComponent,
    LiberroThematicStrategiesCarouselComponent,
    InvestmentsFrequencyPipe,
    LiberroDropdownMenuListComponent,
    LiberroInvestmentSelectDropdownComponent,
    LiberroMobileBottomOverlaySheetComponent,
    LiberroMobileExplainTooltipSheetComponent,
    LiberroSliderComponent,
    LiberroTransactionItemComponent,
    LiberroHelpSectionComponent,
    PreventNumberWheelDirective,
    TooltipAutoCloseDirective,
    MobileExplainTooltipSheetDirective,
    LiberroExplainBoxComponent,
    LiberroPlaceholderContentComponent,
    LiberroDatePickerComponent,
    DayDifferencePipe,
    FeeInfoTooltipComponent,
    TranslateTimeUnitPipe,
    LiberroRegularPaymentComponent,
    LiberroOnetimePaymentComponent,
    LiberroEntryFeePaymentComponent,
    PaymentRowComponent,
    QrPaymentComponent,
    RegularDepositfeeInfoComponent,
    LiberroBoxConsultantComponent,
    NotificationContentParserPipe,
    LiberroInvestmentBadgesComponent,
    TrimTagNamePipe,
    DisclaimerCarouselModule,
    LiberroThematicStrategyPreviewStackComponent,
  ],
  providers: [
    PercentPipe,
    PricePipe,
    TrimTagNamePipe,
  ],
  // fixme - replace with standalone swiper component/template in followup task
  schemas: [
    NO_ERRORS_SCHEMA
  ]
})
export class SharedModule { }
